import createIcon from "./createIcon";

export const VipCheckIcon = createIcon('VipCheck', (props) => {
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none">
      <defs>
        <clipPath id="svg0_7_6">
          <rect x="0" y="0" width="16" height="16" rx="0" />
        </clipPath>
        <linearGradient x1="-0.11666633188724518" y1="-0.9063024520874023" x2="0.9581245941403621" y2="1.3109679913109906" id="svg1_7_96">
          <stop offset="1.9223282113671303%" stopColor="#CEB496" stopOpacity="1" />
          <stop offset="93.5110867023468%" stopColor="#51361C" stopOpacity="1" />
        </linearGradient>
      </defs>
      <g clipPath="url(#svg0_7_6)">
        <path d="M15.4792,1.1328125C10.6504,4.3456624999999995,7.14789,8.4026525,5.56741,10.4354225L1.70755,7.1536825L0,8.6438325L6.66342,15.9998125C7.80709,12.8128125,11.4446,6.5851925,15.8842,2.1578225L15.4792,1.1328125Z" fill="url(#svg1_7_96)" fillOpacity="1" />
      </g>
    </svg>
  );
}); 